import React from 'react'

import PropTypes from 'prop-types'

import Link from 'redux-first-router-link'
import tabsPropType from '../propTypes/tabs.shape'
import Icon from 'components/Icon'
import { NavBarContainer, NavBarItem, NavigationMessage } from 'navigation-ui/nav-bar'

export const NavBar = ({ tabs, className, showIcons = true }) => (
  <NavBarContainer className={className} data-testid="nav-bar">
    {tabs.map(t => (
      <NavBarItem key={t.type} active={t.active}>
        <Link to={t} replace={t.replace}>
          <Icon iconName={t.icon} hidden={!showIcons}/>
          <NavigationMessage id={t.type} hidden={showIcons}/>
        </Link>
      </NavBarItem>
    ))}
  </NavBarContainer>
)

NavBar.propTypes = {
  tabs: tabsPropType,
  className: PropTypes.string
}

export default NavBar
